<template>
	<c-form ref="form" name="custom_fields_value_json" link-parent>
		<c-form-item v-for="(item, i) in fieldList" :key="i" :label="item.field_title" :required="item.config_json.attr.includes('required')" :tip="item.config_json.tip">
			<c-input v-if="item.config_json.type == 'text'"
				:type="item.config_json.attr.includes('textarea') ? 'textarea' : 'text'"
				:name="item.field_code"
				:disabled="item.config_json.attr.includes('readonly')"
				:placeholder="item.config_json.placeholder"
			></c-input>

			<c-input v-else-if="item.config_json.type == 'number'"
				type="number"
				:name="item.field_code"
				:decimal="item.config_json.attr.includes('decimal') ? item.config_json.decimal : 0"
				:disabled="item.config_json.attr.includes('readonly')"
				:placeholder="item.config_json.placeholder"
			></c-input>

			<c-datetime v-else-if="item.config_json.type == 'time'"
				:name="item.field_code"
				:type="item.config_json.format.split('|')[1]"
				:format="item.config_json.format.split('|')[0]"
				:time-accuracy="item.config_json.format.split('|')[2]"
				:disabled="item.config_json.attr.includes('readonly')"
				:placeholder="item.config_json.placeholder"
			></c-datetime>

			<template v-else-if="item.config_json.type == 'option'">
				<template v-if="item.config_json.mode == 'option'">
					<c-checkbox-group v-if="item.config_json.attr.includes('multiple')"
						:name="item.field_code"
						:options="item.config_json.options"
					></c-checkbox-group>

					<c-radio-group v-else
						:name="item.field_code"
						:options="item.config_json.options"
					></c-radio-group>
				</template>

				<c-select v-else
					:name="item.field_code"
					:options="item.config_json.options"
					:multiple="item.config_json.attr.includes('multiple')"
					:placeholder="item.config_json.placeholder"
				></c-select>
			</template>

			<c-upload-file v-else-if="item.config_json.type == 'file'"
				:name="item.field_code"
				:type="item.config_json.suffix.join(',')"
				:multiple="item.config_json.attr.includes('multiple')"
				:sort="false"
			></c-upload-file>

			<c-upload-file v-else-if="item.config_json.type == 'image'"
				:name="item.field_code"
				media
				:multiple="item.config_json.attr.includes('multiple')"
				:sort="false"
			></c-upload-file>
		</c-form-item>
	</c-form>
</template>

<script>
	export default {
		name: 'customForm',

		props: {
			workType: [String, Number]
		},

		data() {
			return {
				fieldList: []
			}
		},

		mounted() {
			this._setFormData = this.$refs.form.set;
			this.$refs.form.set = data => {
				if (!data._default) {
					this._lastData = data;
				}
				this._setFormData(data);
			}
		},

		computed: {
			rule() {
				let rule = {};
				this.fieldList.map(item => {
					if (item.config_json.attr.includes('required')) {
						rule[`custom_fields_value_json.${item.field_code}`] = `${item.field_title}不能为空`
					}
				});
				return rule;
			},

			defaultData() {
				let data = {
					_default: true
				};
				this.fieldList.map(item => {
					if (item.config_json.attr.includes('default')) {
						if (item.config_json.type == 'time') {
							data[item.field_code] = new Date().format(item.config_json.format.split('|')[0]);
						} else {
							data[item.field_code] = item.config_json.default;
						}
					}
				});
				return data;
			}
		},

		methods: {
			init() {
				this._lastData = false;
				this.request({
					url: '/sys_field/list',
					data: {
						work_type_id: this.workType
					},
					success: data => {
						this.fieldList = data;
						this.$nextTick(this.reset);
					}
				});
			},

			reset() {
				this.$refs.form.clear();
				this._setFormData(this._lastData || this.defaultData);
				this._lastData = false;
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
